import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger, Tooltip} from "react-bootstrap";
import {withRouter} from "react-router-dom";

import Accordion from "../../components/Accordion/index";
import CollapsiblePanel from "../../components/Accordion/CollapsiblePanel";
import QuestionForm from "./QuestionForm";
import Loading from "../../components/Loading/index";

class SpecialForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                name: '',
                pointsValue: '',
                moneyValue: '',
                description: '',
                questions: []
            },
            validation: {
                states: {
                    name: null,
                    pointsValue: null,
                    moneyValue: null,
                    questions: [],
                    questionMessage: null
                },
                messages: {
                    name: '',
                    pointsValue: '',
                    moneyValue: '',
                    questions: [],
                    questionMessage: ''
                }
            }
        };

        // handles for special
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangePointsValue = this.handleChangePointsValue.bind(this);
        this.handleChangeMoneyValue = this.handleChangeMoneyValue.bind(this);
        this.handleChangeDescription = this.handleChangeDescription.bind(this);

        // handles for questions
        this.handleChangeQuestionText = this.handleChangeQuestionText.bind(this);
        this.handleChangeQuestionExplanation = this.handleChangeQuestionExplanation.bind(this);
        this.handleChangeQuestionTimeframe = this.handleChangeQuestionTimeframe.bind(this);
        this.handleChangeQuestionEnabled = this.handleChangeQuestionEnabled.bind(this);
        this.handleAddQuestion = this.handleAddQuestion.bind(this);
        this.handleRemoveQuestion = this.handleRemoveQuestion.bind(this);

        // handles for answers
        this.handleChangeAnswerText = this.handleChangeAnswerText.bind(this);
        this.handleChangeAnswerCorrectness = this.handleChangeAnswerCorrectness.bind(this);
        this.handleAddAnswer = this.handleAddAnswer.bind(this);
        this.handleRemoveAnswer = this.handleRemoveAnswer.bind(this);

        // handles for form
        this.validateQuestions = this.validateQuestions.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getSpecial();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getSpecial();
        }
    }

    getSpecial() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.specials + "/" + this.props.match.params.id, config)
                .then((response) => {
                    if (!this._componentWillUnmount) {
                        this.setState({
                            values: {
                                ...response.data
                            },
                            validation: {
                                states: {
                                    ...this.state.validation.states,
                                    questions: response.data.questions.map((question) => {
                                            return {
                                                text: null,
                                                explanation: null,
                                                timeframe: null,
                                                answers: question.answers.map(() => {
                                                    return {text: null}
                                                })
                                            }
                                    })
                                },
                                messages: {
                                    ...this.state.validation.messages,
                                    questions: response.data.questions.map((question) => {
                                        return {
                                            text: '',
                                            explanation: '',
                                            timeframe: '',
                                            answers: question.answers.map(() => {
                                                return {text: ''}
                                            })
                                        }
                                    })
                                }
                            },
                            loading: false
                        });
                    }
                }).catch((error) => {
                    this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst speciál!');
                    this.props.history.push('/specials');
                    console.log("Axios error: ", error);
            });
        }
    }

    handleChangeName(e) {
        let value = e ? e.target.value : this.state.values.name;

        let values = this.state.values;
        values.name = value;

        let validation = this.state.validation;
        validation.states.name = (value === '' ? 'error' : 'success');
        validation.messages.name = (value === '' ? 'Název nesmí být prázdný!' : '');
        this.setState({
            values,
            validation
        });
    }

    handleChangePointsValue(e) {
        let value = e ? e.target.value : this.state.values.pointsValue;

        let values = this.state.values;
        values.pointsValue = value;

        let validation = this.state.validation;
        validation.states.pointsValue = (value === '' ? 'error' : 'success');
        validation.messages.pointsValue = (value === '' ? 'Hodnota v bodech nesmí být prázdná!' : '');
        this.setState({
            values,
            validation
        });
    }

    handleChangeMoneyValue(e) {
        let value = e ? e.target.value : this.state.values.moneyValue;

        let values = this.state.values;
        values.moneyValue = value;

        let validation = this.state.validation;
        validation.states.moneyValue = (value === '' ? 'error' : 'success');
        validation.messages.moneyValue = (value === '' ? 'Hodnota v penězích nesmí být prázdná!' : '');

        this.setState({
            values,
            validation
        });
    }

    handleChangeDescription(e) {
        let value = e ? e.target.value : this.state.values.description;

        let values = this.state.values;
        values.description = value;

        this.setState({
            values
        });
    }

    handleChangeQuestionText(e, index) {
        let value = e ? e.target.value : this.state.values.questions[index].text;

        let values = this.state.values;
        values.questions[index].text = value;

        let validation = this.state.validation;
        validation.states.questions[index].text = (value === '' ? 'error' : 'success');
        validation.messages.questions[index].text = (value === '' ? 'Znění otázky nesmí být prázdné!' : '');

        this.setState({
            values,
            validation
        });
    }

    handleChangeQuestionExplanation(e, index) {
        let value = e ? e.target.value : this.state.values.questions[index].explanation;

        let values = this.state.values;
        values.questions[index].explanation = value;

        let validation = this.state.validation;
        validation.states.questions[index].explanation = (value === '' ? 'error' : 'success');
        validation.messages.questions[index].explanation = (value === '' ? 'Vysvětlení nesmí být prázdné!' : '');

        this.setState({
            values,
            validation
        });
    }

    handleChangeQuestionTimeframe(e, index) {
        let value = e ? e.target.value : this.state.values.questions[index].timeframe;

        let values = this.state.values;
        values.questions[index].timeframe = value;

        let validation = this.state.validation;
        validation.states.questions[index].timeframe = (value === '' ? 'error' : 'success');
        validation.messages.questions[index].timeframe = (value === '' ? 'Časová náročnost otázky nesmí být prázdná!' : '');

        this.setState({
            values,
            validation
        });
    }

    handleChangeQuestionEnabled(question, questionIndex){
        axios.put(this.props.api.questions + "/" + question.id, {
            enabled: !question.enabled,
            access_token: this.props.sessionData.accessToken
        })
        .then(() => {
            let values = this.state.values;
            values.questions[questionIndex].enabled = !question.enabled;
            this.setState({
                values
            })
        })
        .catch((error) => {
            console.log("Axios error: ", error);
        })
    }

    handleChangeAnswerText(e, question, index) {
        let value = e ? e.target.value : this.state.values.questions[question].answers[index].text;

        let values = this.state.values;
        values.questions[question].answers[index].text = value;

        let validation = this.state.validation;
        validation.states.questions[question].answers[index].text = (value === '' ? 'error' : 'success');
        validation.messages.questions[question].answers[index].text = (value === '' ? 'Odpověď nesmí být prázdná!' : '');

        this.setState({
            values,
            validation
        });
    }

    handleChangeAnswerCorrectness(e, question, index) {
        let value = e ? e.target.checked : this.state.values.questions[question].answers[index].correctness;

        let values = this.state.values;
        if (e) {
            values.questions[question].answers.map((answer) => {
                answer.correctness = false;
                return answer;
            });
            values.questions[question].answers[index].correctness = value;
        }

        let validation = this.state.validation;
        validation.states.questions[question].answers[index].correctness = (value === '' ? 'error' : 'success');
        validation.messages.questions[question].answers[index].correctness = (value === '' ? 'Otázka nesmí být prázdná!' : '');

        this.setState({
            values,
            validation
        });
    }

    validateQuestions() {
        let questions = this.state.values.questions;
        let validation = this.state.validation;
        let questionsStates = validation.states.questions;

        validation.states.questionMessage = null;
        validation.messages.questionMessage = '';

        questionsStates.forEach((question, questionIndex) => {
            this.handleChangeQuestionText(null, questionIndex);
            this.handleChangeQuestionExplanation(null, questionIndex);
            this.handleChangeQuestionTimeframe(null, questionIndex);
            let answers = question.answers;
            answers.forEach((answer, answerIndex) => {
                this.handleChangeAnswerText(null, questionIndex, answerIndex);
            });
        });

        let valid = true;

        questionsStates.forEach((question) => {
            question.answers.forEach((answer) => {
                if (Object.values(answer).indexOf('error') >= 0) {
                    valid = false;
                }

                if (!valid) return false;
            });

            if (Object.values(question).indexOf('error') >= 0) {
                valid = false;
            }

            if (!valid) return false;
        });

        // počet odpovědí k otázce
        questions.forEach((question, questionIndex) => {
            // kontrola výběru správné odpovědi
            if (question.answers.map((answer) => answer.correctness).indexOf(true) === -1) {
                validation.messages.questionMessage += (questionIndex + 1) + '. otázka nemá vybranou správnou odpověď! ';
                validation.states.questionMessage = 'error';
                valid = false;
            }
        });

        this.setState({
            validation
        });

        return valid;
    }

    isValid () {
        this.handleChangeName();
        this.handleChangePointsValue();
        this.handleChangeMoneyValue();
        this.validateQuestions();

        let valid = (Object.values(this.state.validation.states).indexOf('error') < 0);
        let validQuestions = this.validateQuestions();

        return valid && validQuestions;

    }

    handleSubmit(e) {
        e.preventDefault();
        if (this.isValid()) {
            this.setState({
                inProcess: true
            });
            this.props.action(this.state.values);
        }
    }

    handleClose() {
        this.props.history.push('/specials');
    }

    /**
     * Add question to specialForm
     */
    handleAddQuestion () {
        let values = this.state.values;
        let newQuestion = {
                text: '',
                explanation: '',
                pointsValue: 0,
                moneyValue: 0,
                difficulty: 0,
                timeframe: 0,
                questionType: ['special'],
                authorId: null,
                answers: [
                    {
                        text: '',
                        order: 1,
                        correctness: false,
                        enabled: true
                    }
                ],
                enabled: true
            }
        ;
        values.questions.push(newQuestion);

        let newStates = {
            text: null,
            explanation: null,
            timeframe: null,
            answers: [{text: null}]
        };

        let newMessages = {
            text: '',
            explanation: '',
            timeframe: '',
            answers: [{text: ''}]
        };

        let validation = this.state.validation;
        validation.states.questions.push(newStates);
        validation.messages.questions.push(newMessages);


        this.setState({
            values,
            validation
        })
    }

    /**
     * Remove question from SpecialForm
     * @param index Index of question to remove
     */
    handleRemoveQuestion(index) {
        let values = this.state.values;
        values.questions.splice(index,1);

        let validation = this.state.validation;
        validation.messages.questions.splice(index,1);
        validation.states.questions.splice(index,1);

        this.setState({
            values,
            validation
        });
    }


    /**
     * Add answer to question of SpecialForm
     * @param question Question to add answer
     */
    handleAddAnswer(question) {
        let values = this.state.values;
        let newAnswer = {
            text: '',
            order: values.questions[question].answers.length + 1,
            correctness: false,
            enabled: true
        };
        values.questions[question].answers.push(newAnswer);

        let newStates = {
            text: null,
        };

        let newMessages = {
            text: '',
        };

        let validation = this.state.validation;
        validation.states.questions[question].answers.push(newStates);
        validation.messages.questions[question].answers.push(newMessages);

        this.setState({
            values,
            validation
        });
    }

    /**
     * Remove answer from question in SpecialForm
     * @param question Index of question to remove answer
     * @param index Index of answer to remove
     */
    handleRemoveAnswer(question, index) {
        let values = this.state.values;
        values.questions[question].answers.splice(index,1);

        let validation = this.state.validation;
        validation.messages.questions[question].answers.splice(index,1);
        validation.states.questions[question].answers.splice(index,1);

        this.setState({
            values,
            validation
        });
    }

    render () {
        let {title, button} = this.props;
        let {name, description, pointsValue, moneyValue, questions} = this.state.values;
        let {messages, states} = this.state.validation;
        let handles = {
            handleAddAnswer: this.handleAddAnswer,
            handleRemoveAnswer: this.handleRemoveAnswer,
            handleChangeQuestionText: this.handleChangeQuestionText,
            handleChangeQuestionExplanation: this.handleChangeQuestionExplanation,
            handleChangeQuestionTimeframe: this.handleChangeQuestionTimeframe,
            handleChangeAnswerText: this.handleChangeAnswerText,
            handleChangeAnswerCorrectness: this.handleChangeAnswerCorrectness
        };

        const tooltipEnable = (
            <Tooltip id="tooltip-enable">Zakázat otázku</Tooltip>
        );
        const tooltipDisable = (
            <Tooltip id="tooltip-disable">Povolit otázku</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit otázku</Tooltip>
        );

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="row">
                                    <div
                                        className="col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-lg-6 col-md-6 col-sm-6">
                                        <h4>Základní údaje</h4>
                                        <FormGroup controlId="name" validationState={states.name}>
                                            <ControlLabel>Název <span className="required">*</span></ControlLabel>
                                            <FormControl
                                                type="text"
                                                value={name}
                                                placeholder="Zadejte název speciálu"
                                                onChange={this.handleChangeName}
                                            />
                                            <FormControl.Feedback/>
                                            <HelpBlock>{messages.name}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup controlId="pointsValue" validationState={states.pointsValue}>
                                            <ControlLabel>Hodnota v bodech <span
                                                className="required">*</span></ControlLabel>
                                            <FormControl
                                                type="number"
                                                value={pointsValue}
                                                placeholder="Zadejte hodnotu v bodech"
                                                min="0"
                                                onChange={this.handleChangePointsValue}
                                            />
                                            <FormControl.Feedback/>
                                            <HelpBlock>{messages.pointsValue}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup controlId="moneyValue" validationState={states.moneyValue}>
                                            <ControlLabel>Hodnota v penězích <span
                                                className="required">*</span></ControlLabel>
                                            <FormControl
                                                type="number"
                                                value={moneyValue}
                                                placeholder="Zadejte hodnotu v penězích"
                                                min="0"
                                                onChange={this.handleChangeMoneyValue}
                                            />
                                            <FormControl.Feedback/>
                                            <HelpBlock>{messages.moneyValue}</HelpBlock>
                                        </FormGroup>
                                        <FormGroup controlId="description">
                                            <ControlLabel>Popis</ControlLabel>
                                            <FormControl
                                                componentClass="textarea"
                                                value={description}
                                                placeholder="Zadejte popis speciálu"
                                                onChange={this.handleChangeDescription}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h4>Otázky</h4>
                                        <Accordion>
                                            {
                                                [...questions].map((question, index) => {
                                                    let heading = question.name ? "Otázka č. " + question.name : "Nová otázka";
                                                    let values = this.state.values.questions[index];
                                                    let states = this.state.validation.states.questions[index];
                                                    let messages = this.state.validation.messages.questions[index];
                                                    let validation = {states, messages};
                                                    return (
                                                        <div key={index} className="row">
                                                            <div className="col-lg-11">
                                                                <CollapsiblePanel heading={heading}>
                                                                    <QuestionForm index={index} data={values}
                                                                                  validation={validation}
                                                                                  handles={handles}/>
                                                                </CollapsiblePanel>
                                                            </div>
                                                            <div className="col-lg-1">
                                                                {
                                                                    question.enabled &&
                                                                    <OverlayTrigger placement="top"
                                                                                    overlay={tooltipEnable}>
                                                                        <FontAwesome name="unlock" size="2x"
                                                                                     onClick={() => this.handleChangeQuestionEnabled(question, index)}
                                                                                     className="cursor-p"/>
                                                                    </OverlayTrigger>
                                                                }
                                                                {
                                                                    !question.enabled &&
                                                                    <OverlayTrigger placement="top"
                                                                                    overlay={tooltipDisable}>
                                                                        <FontAwesome name="lock" size="2x"
                                                                                     onClick={() => this.handleChangeQuestionEnabled(question, index)}
                                                                                     className="cursor-p"/>
                                                                    </OverlayTrigger>
                                                                }
                                                                {' '}
                                                                {
                                                                    //!question.used &&
                                                                    <OverlayTrigger placement="top"
                                                                                    overlay={tooltipRemove}>
                                                                        <FontAwesome className="cursor-p" name="trash"
                                                                                     size="2x"
                                                                                     onClick={() => this.handleRemoveQuestion(index)}/>
                                                                    </OverlayTrigger>
                                                                }
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </Accordion>
                                        <FormGroup validationState={this.state.validation.states.questionMessage}>
                                            <HelpBlock>{this.state.validation.messages.questionMessage}</HelpBlock>
                                        </FormGroup>
                                        <Button type="button" className="btn btn-success"
                                                onClick={this.handleAddQuestion}>Přidat otázku</Button>
                                    </div>
                                </div>
                                <div className="ln-solid"/>
                                <FormGroup>
                                    <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-4">
                                        <Button className="btn-primary" type="button"
                                                onClick={this.handleClose}>Zpět</Button>
                                        <Button type="submit" disabled={this.state.inProcess}
                                                className="btn btn-success">{button}</Button>
                                        {this.state.inProcess && <Loading/>}
                                    </div>
                                </FormGroup>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(SpecialForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Specials/SpecialForm.js
 **/